export default __webpack_public_path__ + "svg/why/positive.svg?eae7b259";